const makeGuards = ({i18n, settings}) => ({
    forceLoadApplications: (context, event) => {
        return context.forceLoadApplicationsFlag;
    },
    forceLoadDevices: (context, event) => {
        return context.forceLoadDevicesFlag;
    },
    forceLoadProjects: (context, event) => {
        return context.forceLoadProjectsFlag;
    },
    forceLoadWarehouses: (context, event) => {
        return context.forceLoadWarehousesFlag;
    },
});

export {makeGuards};
